<ng-container [formGroup]="newEditForm">
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="poligonoCatastral" maxlength="3">
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="parcelaCatastral" maxlength="5">
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="text" formControlName="refCatastral" title="Referencia Catastral" minlength="8" maxlength="20">
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" [ngClass]="{'disabled': (!campanyaHabilitada || getRolePermission())}" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" [ngClass]="{'disabled': (!campanyaHabilitada || getRolePermission())}" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" *ngIf="this.role === 'Administrador' || this.claims.includes('CAT_Upd')" [ngClass]="{'disabled': (!campanyaHabilitada)}" (click)="edit(cultivoCatastro)"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" *ngIf="this.role === 'Administrador' || this.claims.includes('CAT_Del')" [ngClass]="{'disabled': (!campanyaHabilitada)}" app-click-stop-propagation (click)="askDelete(cultivoCatastro)"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
      <header>
        <h4>{{ 'global.eliminar.descripcion' | translate }}</h4>
      </header>
      <content>
        <p>{{ 'global.eliminar.confirmacion' | translate }}</p>
      </content>
      <footer>
        <button class="secondary" (click)="closeModal()">{{ 'global.cancelar' | translate }}</button>
        <button (click)="delete()">{{ 'global.confirmar' | translate }}</button>
      </footer>
    </div>
</div>